var SpriteSymbol = require("svg-baker-runtime/browser-symbol");
var sprite = require("svg-sprite-loader/runtime/browser-sprite.build");
var symbol = new SpriteSymbol({
  "id": "meta-63",
  "use": "meta-63-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol viewBox=\"0 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\" id=\"meta-63\"><g stroke=\"#4E4E4E\" stroke-width=\"1.3\" fill=\"none\" fill-rule=\"evenodd\"><rect x=\"9.65\" y=\"6.65\" width=\"12.033\" height=\"18.7\" rx=\"2\" /><path d=\"M9 14h12.976\" /><path d=\"M12 10v2m0 4v4\" stroke-linecap=\"round\" /></g></symbol>"
});
var result = sprite.add(symbol);
module.exports = symbol